// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"520404d8","453":"eaf825bd","455":"34a3ac2a"}[chunkId] + ".chunk.js";
};